import script from "./ContactDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactDetails.vue?vue&type=script&lang=ts&setup=true"

import "./ContactDetails.vue?vue&type=style&index=0&id=0cc2ec2f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cc2ec2f"]])

export default __exports__